import { Theme as AugmentedTheme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useHistory } from 'react-router-dom';
import Box from 'web-library/stories/atom/Box/Box';
import Button from 'web-library/stories/atom/Button/Button';
import Typography from 'web-library/stories/atom/Typography/Typography';

import {typographyTheme} from "web-library/theme/helper/tssHelper"
const useStyles = makeStyles()((theme) =>
({
  errorTitle: {
    color: theme.color.state.stateError,
     ...typographyTheme(theme, 'h3'),
  },
  buttonContainer: {
    paddingTop: theme.spacing(2),
  },
}));

const PaymentLinkError = (props: any) => {
  const { typographyMessage, buttonMessage } = props;
  const { classes } = useStyles();
  const history = useHistory();

  return (
    <Box>
      <Typography className={classes.errorTitle}>{typographyMessage}</Typography>

      <Box className={classes.buttonContainer}>
        <Button onClick={() => history.push('/')}>{buttonMessage}</Button>
      </Box>
    </Box>
  );
};

export default PaymentLinkError;
